import { styled } from '@mui/material/styles';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import TextInput from '../../../forms/TextInput';
import SelectMenu from '../../../forms/SelectMenu';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import * as lookupSlice from '../../../../data/lookup.slice';

const PREFIX = 'PassengerIngestionServerConfigForm';

const classes = {
  container: `${PREFIX}-container`,
  form: `${PREFIX}-form`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    marginLeft: theme.spacing(2),
  },
  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(1),
    gap: theme.spacing(2),
    width: 500,
  },
}));

interface PassengerIngestionServerConfigFormProps {
  isNew: boolean;
  formHook: UseFormReturn<any, any>;
}

export default function PassengerIngestionServerConfigForm({
  isNew,
  formHook,
}: PassengerIngestionServerConfigFormProps) {
  const { t } = useTranslation('common');
  const requiredFieldMessage = t('common.requiredField');
  const ingestionCronJobs = useAppSelector(
    lookupSlice.selectIngestionCronJobsUnfiltered,
  );

  return (
    <StyledBox className={classes.container}>
      <Box className={classes.form}>
        <TextInput
          name="eligibilityFileSourceURI"
          label={t('client.eligibilityFileSourceURI')}
          control={formHook.control}
          required={true}
          rules={{ required: requiredFieldMessage }}
        />
        <TextInput
          name="eligibilityFileLegacyCopyPath"
          label={t('client.eligibilityFileLegacyCopyPath')}
          control={formHook.control}
        />
        <SelectMenu
          label={t('client.ingestionCronJobBC')}
          name="ingestionCronJobBC"
          values={ingestionCronJobs.filter((cj) => cj.isActive)}
          valueAttr="ingestionCronJobBC"
          labelAttr="ingestionCronJobBC"
          required={true}
          control={formHook.control}
          rules={{ required: requiredFieldMessage }}
        />
        {isNew && (
          <>
            <TextInput
              name="clientUsername"
              label={t('users.username')}
              control={formHook.control}
              required={true}
              rules={{ required: requiredFieldMessage }}
            />
            <TextInput
              name="clientPassword"
              label={t('users.password')}
              control={formHook.control}
              required={true}
              rules={{ required: requiredFieldMessage }}
            />
          </>
        )}
      </Box>
    </StyledBox>
  );
}
